import { Component } from '@angular/core';

/** Icono del splitter de SmartOLT, en la cabecera del modal y de la tarjeta del splitter. */
@Component({
  selector: 'app-odb-icon',
  standalone: true,
  host: { class: 'inline-block shrink-0' },
  template: `
    <svg viewBox="0 0 36 42" class="h-full w-full text-slate-500" aria-hidden="true">
      <defs>
        <linearGradient id="onuOdbBox" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#f8fafc" />
          <stop offset="1" stop-color="#dbe3ee" />
        </linearGradient>
      </defs>
      <rect
        x="10"
        y="4"
        width="16"
        height="27"
        rx="4"
        fill="url(#onuOdbBox)"
        stroke="currentColor"
        stroke-width="1.4"
      />
      <rect
        x="8.6"
        y="9"
        width="2"
        height="6"
        rx=".8"
        fill="#cbd5e1"
        stroke="currentColor"
        stroke-width=".55"
      />
      <rect
        x="25.4"
        y="9"
        width="2"
        height="6"
        rx=".8"
        fill="#cbd5e1"
        stroke="currentColor"
        stroke-width=".55"
      />
      <rect
        x="8.6"
        y="22"
        width="2"
        height="6"
        rx=".8"
        fill="#cbd5e1"
        stroke="currentColor"
        stroke-width=".55"
      />
      <rect
        x="25.4"
        y="22"
        width="2"
        height="6"
        rx=".8"
        fill="#cbd5e1"
        stroke="currentColor"
        stroke-width=".55"
      />
      <path d="M14 21h8M14 24h8" stroke="#94a3b8" stroke-width="1.3" stroke-linecap="round" />
      <path d="M18 31v8" stroke="#0064c8" stroke-width="2.5" stroke-linecap="round" />
      <path
        d="M15.2 16.5h5.6l-2.8-6.2z"
        fill="none"
        stroke="#64748b"
        stroke-width="1.1"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class OdbIconComponent {}
